export default __webpack_public_path__ + "static/media/product-selector-background.e7d5176f.png";